import React from 'react';

class Contact extends React.Component {
   constructor (props) {
       super(props);
       this.state = {};
   }

   render () {
       return (null);
   }
};

export default Contact;
